<template>
  <v-container>
    Home
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DashboardHome",
  mounted() {
    this.updateWindowTitle({ newTitle: "Dashboard" });
  },
  methods: {
    ...mapActions(["updateWindowTitle"]),
  },
};
</script>
